import { Application } from '@hotwired/stimulus';

// Application Stimulus (window.Stimulus : console et tests).
const application = Application.start();
window.Stimulus = application;

export { application };
